import { render, staticRenderFns } from "./GetInTouchForm.vue?vue&type=template&id=499c5dc2"
import script from "./GetInTouchForm.vue?vue&type=script&lang=js"
export * from "./GetInTouchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports